module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Delete-user-3070fea4f59e5ac538756a127a4d8981.svg";